module.exports = __webpack_public_path__ + "static/media/door-closed.792c716d.svg";